// Dependencies
import { useEffect, useState } from 'react';
import { Backdrop } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useSelector } from 'react-redux';

//Assets
import { themBackdrop } from '../config/theme';
import { RootState } from '../store';
import styles from './styles/loading-styles.component.module.css';

// Paths del logo (src/assets/svg/logo.svg) separados para animarlos de forma individual
const MONOGRAM = [
	'M395.35,83.9c-3.79,22.07,9.07,41.920,28.69,49.56,20.1,7.83,42.88-.2,54.28-17.93l.18,18.8c-23.7,20.93-58.44,19.05-80.04-2.81-21.620-21.880-21.640-57.960-.55-80.12,21.38-22.46,56.57-24.45,80.47-3.74l-.24,19.22c-10.75-16.01-28.93-24.07-47.51-20.13-17.6,3.73-31.97,17.87-35.28,37.15Z',
	'M556.02,100.85c-22.48,20.09-55.65,20.03-77.56-.3l.16-18.9c21.99-19.91,54.87-20.73,77.43-.19,7.41-13.33,9.05-29.07,1.58-44.06-6.09-12.21-18.48-21.95-33.97-24.37-18.05-2.82-34.53,5.68-44.93,21.04l.1-19.29c15.4-13.12,35.15-18.350,55.32-12.21,17.01,5.17,32.21,18.54,38.03,37.05,5.66,18.02,2.79,36.62-7.49,51.88,8.51,11.66,11.77,26.12,9.91,40.95-2.64,21.11-17.44,38.24-35.7,45.61-21.1,8.51-43.82,3.69-60.35-10.52l.18-19.06c9.14,12.2,20.74,19.89,34.51,21.13,15.13,1.36,29.27-4.84,38.92-16.44,12.06-14.49,14.18-34.54,3.87-52.3ZM548.23,91.3c-17.56-15.88-43.52-17-61.43-.19,16.78,15.85,43.46,16.18,61.43.19Z',
];

const WORDMARK = [
	// CURRIE
	'M26.2,182.28c10.15,6.19,22.61,5.53,32.28-.06,6.65-3.85,10.43-9.41,12.02-17.11l12.44,1.07c-1.57,8.06-4.74,14.47-10.62,19.87-15.02,13.79-37.72,15.91-54.72,4.32C5.08,181.830-.79,167.48.08,152.56c1.46-24.98,23.68-42.47,48.4-38.86,17.7,2.59,32.58,14.53,33.86,31.61l-12.23.49c-1.33-8.36-6.53-14.4-14.02-17.96-9.33-4.43-19.13-4.98-28.78.25-7.82,4.24-13.81,12.73-15.11,22.99-1.53,12.12,2.89,24.43,13.99,31.19Z',
	'M140.02,114.78l11.62-.4.06,52.98c0,5.84-1.9,12.1-5.19,16.79-8.04,11.45-22.02,15.67-35.25,12.57-15.16-3.54-23.880-16.16-23.86-31.48l.07-50.69,11.48-.04.17,53.43c.04,11.31,9.95,18.5,20.44,18.57,11.2.08,20.31-7.71,20.34-19.26l.12-52.48Z',
	'M201.01,196.44l-1.98-18.59c-.9-8.45-7.88-15.28-16.38-15.42l-13.3-.23-.16,34.63-11.57.05.14-82.38,35.8.27c11.92.09,21.67,10.9,22.35,22.28.5,11.08-4.97,19.8-15.84,23.66,5.51,2.92,9.11,7.56,10.19,14l3.7,22.14-12.95-.42ZM193.98,151.31c7.7-.09,10.79-8.43,9.91-14.33s-5.6-11.08-12.78-11.2l-21.97-.36v26.18s24.85-.28,24.85-.28Z',
	'M264.85,196.63l-1.47-17.23c-.83-9.71-8.07-16.91-17.82-17.03l-12.04-.15.02,34.48-11.83-.23.04-82,35.78.17c8.26.04,15.53,6.07,18.9,11.67,4.76,7.91,4.3,16.69.33,24.33-2.56,4.93-7.61,8.09-12.38,10.24,4.68,2.79,8.55,6.86,9.47,12.01l4.24,23.82-13.25-.09ZM255.1,151.87c7.72.08,13.12-6.04,12.98-13s-5.13-12.91-13-13.08l-21.52-.46-.22,26.31,21.76.23Z',
	'M297.37,196.78L285.51,196.87L285.61,114.67L297.42,114.55L297.37,196.78Z',
	'M347.44,158.87L314.57,158.61L314.8,185.33L351.59,185.38L351.36,196.63L302.74,196.41L302.96,114.67L351.52,114.4L351.24,125.77L314.56,125.46L314.64,147.42L347.6,147.31L347.44,158.87Z',
	// & BROWN
	'M62.13,279.16l19.68,15.01-15.49.46-10.7-8.54c-11.3,9.28-26.32,11.92-40.01,7.2-7.15-2.46-12.59-8.26-14.35-14.37-2.24-7.8-1.16-15.95,4.39-21.76l10.06-8.12c-6.17-7.2-9.48-17.41-5.58-26.33,3.16-7.23,10.7-10.97,17.18-11.67,8.22-.88,15.49,1.57,20.57,8.07,5.47,7,4.51,17.07-1.76,23.71-4.05,4.29-9.31,6.96-14.46,9.91l21.55,19.23c3.67-6.23,4.99-10.99,6.11-17.36l11.89.57c-1,8.7-3.07,16.18-9.09,23.99ZM25.73,244.93l9.57-5.22c5-2.73,6.88-9.92,3.61-14.67-2.29-3.33-6.62-4.82-10.45-4.4-3.12.34-7.44,3.27-8.29,6.83-1.58,6.56.94,12.55,5.57,17.46ZM45.83,279.46l-21.87-19.67c-.45-.71-1.9-2.75-2.59-2.3l-2.64,1.69c-5.08,3.25-7.7,8.37-6.82,14.18.76,5.01,4.44,8.94,9.92,10.81,8.23,2.81,17.51.8,24.01-4.72Z',
	'M138.31,250.89c5.94,2.86,10.28,6.56,12.18,12.43,2.28,7.04,1.73,14.55-2.98,20.96-3.3,4.49-9.93,9.52-17.18,9.61l-35.8.43.02-81.97,32.08.14c7.71.03,15.32,3.79,19.51,10.13,6.48,9.81,2.97,22.22-7.83,28.27ZM126.92,246.19c6.74-.11,10.75-6,10.79-11.5.04-4.35-3.98-10.79-9.62-10.96l-22.31-.67.15,23.46,20.98-.33ZM128.9,282.93c7.39-.17,11.43-7.55,11.2-13.24-.25-6.11-5.15-11.78-12.18-11.93l-22.02-.45.02,26.14,22.98-.52Z',
	'M200.76,294.4l-1.8-18.47c-.75-7.68-6.04-14.78-13.73-15.34l-16.05-1.18-.09,35.03-11.48-.22-.07-81.77,34.81.16c14.23.07,24.29,11.83,23.29,25.56-.73,9.95-6.33,17.39-16.29,20.41,5.1,2.26,9.31,6.66,10.37,12.48l4.32,23.56-13.27-.23ZM191.6,249.69c8.44.08,12.82-7.02,12.31-13.94-.46-6.29-5.26-12.1-12.57-12.19l-22.08-.28-.22,26.2,22.57.22Z',
	'M265.14,295.15c-26.94,2.73-47.8-17.91-46.49-44.06,1.13-22.36,18.59-39.37,40.48-40.2,22.05-.84,41.28,15.88,43.06,38.27,1.83,23.06-13.35,43.59-37.05,45.99ZM285.03,270.91c9.12-13.21,6.29-32.13-5.85-42.03-12.52-10.2-29.73-9.09-40.390,2.62-9.73,10.68-11.03,26.65-3.44,38.76,5.63,8.97,14.77,13.76,24.75,13.92s18.7-4.260,24.93-13.27Z',
	'M399.8,212.44L411.92,212.29L384.4,294.6L374.92,294.64L354.2,230.04L353.08,234.86L333.68,294.63L323.78,294.1L296.64,212.31L308.75,212.3L329.29,276.42L349.47,212.32L359.23,212.49L379.92,276.61L387.36,250.2L399.8,212.44Z',
	'M478.41,294.18L468.26,294.41L426.38,232.38L426.46,294.4L414.55,294.31L414.66,247.2L415.12,212.29L425.4,212.33L451.25,250.33L467.09,274.35L467.22,212.35L478.54,212.27L478.41,294.18Z',
];

const ModalLoading = () => {
	const { loading } = useSelector((state: RootState) => state.loading);
	// Cambia en cada apertura para reiniciar la animación de entrada
	const [cycle, setCycle] = useState(0);

	useEffect(() => {
		if (loading) setCycle((prev) => prev + 1);
	}, [loading]);

	return (
		<ThemeProvider theme={themBackdrop}>
			<Backdrop
				open={loading}
				className={styles.backdrop}
				transitionDuration={{ enter: 250, exit: 350 }}
			>
				<div
					key={cycle}
					className={styles.containerLoading}
					role="status"
					aria-live="polite"
				>
					<div className={styles.glow} />
					<svg
						className={styles.logo}
						viewBox="0 0 575.1 295.59"
						aria-hidden="true"
					>
						<defs>
							<linearGradient
								id="loading-shine-gradient"
								x1="0"
								x2="1"
								y1="0"
								y2="0"
							>
								<stop offset="0" stopColor="#fff" stopOpacity="0" />
								<stop offset="0.5" stopColor="#fff" stopOpacity="0.9" />
								<stop offset="1" stopColor="#fff" stopOpacity="0" />
							</linearGradient>
							<mask id="loading-wordmark-mask">
								{WORDMARK.map((d) => (
									<path key={d} d={d} fill="#fff" />
								))}
							</mask>
						</defs>

						<g className={styles.monogram}>
							{MONOGRAM.map((d, i) => (
								<path
									key={d}
									d={d}
									pathLength={1}
									className={styles.monogramPath}
									style={{ animationDelay: `${i * 0.25}s` }}
								/>
							))}
						</g>

						<g>
							{WORDMARK.map((d, i) => (
								<path
									key={d}
									d={d}
									className={styles.letter}
									style={{ animationDelay: `${0.15 + i * 0.05}s` }}
								/>
							))}
						</g>

						<g mask="url(#loading-wordmark-mask)">
							<rect
								className={styles.shine}
								x="-200"
								y="100"
								width="200"
								height="200"
								fill="url(#loading-shine-gradient)"
							/>
						</g>
					</svg>

					<div className={styles.progress}>
						<span className={styles.progressBar} />
					</div>

					<p className={styles.textLoading}>
						Cargando
						<span className={styles.dots}>
							<span>.</span>
							<span>.</span>
							<span>.</span>
						</span>
					</p>
				</div>
			</Backdrop>
		</ThemeProvider>
	);
};

export default ModalLoading;
